import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { GET_EARNED_VS_PAID_BUDGET } from "src/api-setup/api-endpoints";
import { API_CONSTANTS } from "../utils/constants";
import { transformDateTime } from "src/lib/date-time.util";

export const getEarnedVsPaidData = async (cookiesData, dispatch, providerId, startDate, endDate, scope = {}) => {
  if (!cookiesData || !providerId) {
    return {
      earnedVsPaidData: { earnedAmount: "$0", paidAmount: "$0" },
      payDistributionData: [],
    };
  }

  try {
    const apiHeaders = generateHeader();

    const startDateString = startDate
      ? `${transformDateTime({
          date: startDate,
          format: "YYYY-MM-DD",
          includeTime: false,
        })} 00:00:00`
      : null;
    const endDateString = endDate
      ? `${transformDateTime({
          date: endDate,
          format: "YYYY-MM-DD",
          includeTime: false,
        })} 23:59:59`
      : null;

    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_provider_id: providerId,
      in_start_date: startDateString,
      in_end_date: endDateString,
      in_sort_number: API_CONSTANTS.DEFAULT_SORT_NUMBER,
      in_sort_order: API_CONSTANTS.DEFAULT_SORT_ORDER_ASC,
      ...scope,
    };

    const response = await POSTAPI(false, GET_EARNED_VS_PAID_BUDGET, null, apiHeaders, requestBody, dispatch);

    if (response && response.data && response.data.out_parameters) {
      const { out_ret_code } = response.data.out_parameters;
      const rowResult = response.data.row_result;

      if (out_ret_code === API_CONSTANTS.SUCCESS_CODE || out_ret_code === API_CONSTANTS.RECORDS_NOT_FOUND_CODE) {
        if (rowResult) {
          const earnedVsPaidData = {
            earnedAmount: `$${Number(rowResult.earned_budget || 0).toFixed(2)}`,
            paidAmount: `$${Number(rowResult.paid_budget || 0).toFixed(2)}`,
          };

          // Extract contract_type data for pay distribution chart
          let payDistributionData = [];
          if (rowResult.contract_type) {
            const contractTypes = Object.keys(rowResult.contract_type);
            if (contractTypes.length > 0) {
              payDistributionData = contractTypes.map((contractName) => ({
                category_name: contractName,
                total_used_budget: parseFloat(rowResult.contract_type[contractName].total_used_budget || 0),
                color_code: rowResult.contract_type[contractName].color_code || "#808080",
              }));
            }
          }

          return { earnedVsPaidData, payDistributionData };
        }
      }
    }

    return {
      earnedVsPaidData: { earnedAmount: "$0", paidAmount: "$0" },
      payDistributionData: [],
    };
  } catch (error) {
    console.error("Error fetching earned vs paid data:", error);
    return {
      earnedVsPaidData: { earnedAmount: "$0", paidAmount: "$0" },
      payDistributionData: [],
    };
  }
};
